import React, { useCallback, useEffect, useState } from "react";
import { useFormik } from "formik";
import { Button, Col, Form, Row, Spinner, Tab, Tabs } from "react-bootstrap";
import { AiOutlineCheck } from "react-icons/ai";
import { VscReplace } from "react-icons/vsc";
import { BiEdit } from "react-icons/bi";
import { GoAlert } from "react-icons/go";
// import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
// import ReactTooltip from "react-tooltip";
import DOMPurify from "dompurify";
import { useDispatch, useSelector } from "react-redux";
import { BsDownload } from "react-icons/bs";
import { signalrActions } from "../../redux/signalr";
import FileDownloader from "../../components/UI/Button/FileDownloader";
import FormAlert from "../../components/UI/FormAlert/FormAlert";
import HtmlEditor from "../../components/UI/HtmlEditorInput/HtmlEditor";
import OverlayInfoAdicional from "../../components/UI/Overlays/OverlayInfoAdicional";
import SelectDiretor from "../../components/UI/SelectInput/SelectDiretor";
import SelectInputCachedFormik from "../../components/UI/SelectInput/SelectInputCachedFormik";
import TextInputFormik from "../../components/UI/TextInput/TextInputFormik";
import useApiClient, { apiRoutes } from "../../hooks/apiClient";
// import ListaContribuinteAcaoFiscal from "../SPF/ListaContribuinteAcaoFiscal";
import ListaExecutores from "./ListaExecutores";
import useSetGuard from "../../hooks/useSetGuard";
import { formatarData } from "../../components/Formatters/DateTime";
import Id from "../../components/Formatters/Id";
import IE from "../../components/Formatters/IE";
import useGerarOrdemServico from "./hooks/useGerarOrdemServico";
import EfisModal from "../../components/UI/EfisModal/EfisModal";
import useBuscaTextoPadraoOs from "./hooks/useBuscaTextoPadraoOs";
import ButtonImage from "../../components/UI/Button/ButtonImage";
import useDocumentoSpf from "../SPF/hooks/useDocumentoSpf";

const documentoSpf = { exibir: () => {} };

const exibirDocumento = (dadosSpf) => {
  documentoSpf.exibir(dadosSpf);
};

const showButtonDownload = (dadosSpf) => {
  if (!dadosSpf.documentoAssinado) {
    return (
      <ButtonImage
        className="btn-lg text-success p-0"
        buttonImage={<BsDownload size="16" color="#e37023" />}
        tooltipImage={`Baixar SPF Nº ${dadosSpf.numeroAberturaProcesso}`}
        onClick={() => exibirDocumento(dadosSpf)}
      />
    );
  }

  return (
    <FileDownloader binario={dadosSpf.documentoAssinado} tooltip={`Baixar SPF Nº ${dadosSpf.numeroAberturaProcesso}`} />
  );
};

const validationSchema = Yup.object().shape({
  sequencialTipoAcao: Yup.string().default(""),
  dataInicio: Yup.date(),
  dataFim: Yup.date(),
  contribuintes: Yup.array()
    .default([])
    .test("qtd-contribuinte", "Selecione pelo menos 1 contribuinte", (value) => (value || []).length > 0),
  textoPadrao: Yup.string()
    .default("")
    .test("texto-padrao", "Informe o Texto Complementar", (value) => {
      if ((value || []).length === 0 || value === undefined || value === null || value === "<p><br></p>") return false;

      return true;
    }),
  quantidadeDiasOs: Yup.number()
    .required("Informe a quantidade máxima de dias da OS")
    .positive()
    .integer()
    .min(1, "Valor mínimo deve ser 1")
    .max(999, "Valor máximo deve ser 999"),
  procedimentos: Yup.array().default([]),
  codigoDiretor: Yup.string().default("").required("Informe o Diretor"),
  listaExecutoresOs: Yup.array()
    .default([])
    .test("qtd-executor", "Selecione pelo menos 1 executor", (value) => (value || []).length > 0),
  numeroAberturaProcesso: Yup.string().default(""),
  sequencialDenuncia: Yup.string().default(""),
  sequencialParteServico: Yup.string().default(""),
  textoPadraoOs: Yup.string().default(""),
});

const initialValues = {};

validationSchema._nodes.forEach((key) => {
  if (key === "procedimentos" || key === "contribuintes" || key === "listaExecutoresOs") {
    initialValues[key] = [];
  } else if (key === "quantidadeDiasOs") {
    initialValues[key] = 60;
  } else {
    initialValues[key] = "";
  }
});

const FormSpfGerarOs = ({ history, location }) => {
  const { state } = location;

  // const [documentoContribuinte, setDocumentoContribuinte] = useState("");
  const [cpf, setCpf] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [procedimentos, setProcedimentos] = useState([]);
  const [dados, setDados] = useState({});
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [sqOrgao, setSqOrgao] = useState();
  const [sgOrgao, setSgOrgao] = useState("");
  const [listaOs, setListaOs] = useState([]);
  const [sequencial, setSequencial] = useState();
  const [titulo, setTitulo] = useState("");
  const setGuardClient = useSetGuard();
  const { filaAssinaturaSucessoStateKey, filaAssinaturaFalhaStateKey } =
    useSelector((stateSignalr) => stateSignalr.signalr) || {};

  const dispatch = useDispatch();

  const { request: requestSafePayload, data: dataSafePayload } = useApiClient();

  const formik = useFormik({ initialValues, validationSchema });

  const { textoPadrao } = useBuscaTextoPadraoOs({ formik });

  const { values, setFieldValue, setValues } = formik;

  const { gerarOrdemServico, gerarOrdemServicoIsLoading, gerarOrdemServicoErrors, gerarOrdemServicoData } =
    useGerarOrdemServico({ formik });

  const [showTextoOs, setShowTextoOs] = useState(true);
  const [showViewSubstituicao, setShowViewSubstituicao] = useState(false);
  const [textoBody, setTextoBody] = useState("");
  const [desabilitarBotao, setDesabilitarBotao] = useState(false);

  useEffect(() => {
    if (gerarOrdemServicoData) {
      const listaTicket = [];
      const listaOS = [];

      gerarOrdemServicoData.result.value.forEach((x) => {
        listaTicket.push(x.ticket);
        listaOS.push(x.nuOrdemServico);
      });
      setListaOs(listaOS);
      requestSafePayload(apiRoutes.usuarios.arquivo.selecionar, listaTicket);
    }
  }, [gerarOrdemServicoData, requestSafePayload]);

  const assinaturaHandler = useCallback(
    (safePayload) => {
      setGuardClient.assinar(safePayload);
    },
    [setGuardClient],
  );

  useEffect(() => {
    if (dataSafePayload) {
      assinaturaHandler(dataSafePayload.result);
    }
  }, [dataSafePayload, assinaturaHandler]);

  useEffect(() => {
    if (filaAssinaturaSucessoStateKey) {
      toast.success(`Ordem(ns) de Serviço ${listaOs}  gerada(s) com sucesso.`);
      history.push("/app/os/gerarOs");
    }
    return () => {
      dispatch(signalrActions.clearState("filaAssinaturaSucessoStateKey"));
    };
  }, [dispatch, filaAssinaturaSucessoStateKey, history, listaOs]);

  useEffect(() => {
    dispatch(signalrActions.clearState("filaAssinaturaFalhaStateKey"));
  }, [dispatch, filaAssinaturaFalhaStateKey]);

  // Carregar item
  const {
    request: consultaFormRequest,
    data: consultaFormData,
    errors: consultaFormErrors,
    isLoading: consultaFormIsLoading,
  } = useApiClient();

  useEffect(() => {
    if (state && state.itemKey) {
      consultaFormRequest(apiRoutes.fiscalizacao.ordemservico.consultaSpfHomologada, { id: state.itemKey });
      delete state.itemKey;
    }
  }, [consultaFormRequest, state]);

  useEffect(() => {
    setValues((curr) => ({
      ...curr,
      textoPadraoOs: textoPadrao,
      contribuintes: [state.contribuintes],
    }));
  }, [setValues, textoPadrao, state.contribuintes]);

  useEffect(() => {
    if (!values.numeroAberturaProcesso && consultaFormData && consultaFormData.result.length) {
      setFieldValue("dataInicio", consultaFormData.result[0].dataInicio);
      setFieldValue("dataFim", consultaFormData.result[0].dataFim);
      setFieldValue("textoPadrao", consultaFormData.result[0].textoPadrao);
      setFieldValue("procedimentos", []);
      setFieldValue("numeroAberturaProcesso", consultaFormData.result[0].numeroAberturaProcesso);
      setFieldValue("sequencialDenuncia", consultaFormData.result[0].sequencialDenuncia);
      setFieldValue("sequencialParteServico", consultaFormData.result[0].sequencialParteServico);
      setFieldValue("dataInclusao", consultaFormData.result[0].dataInclusao);
      setFieldValue("sequencialTipoAcao", consultaFormData.result[0].sequencialTipoAcao);
      setFieldValue("textoPadraoOs", textoPadrao ?? consultaFormData.result[0].textoPadraoOs);
      setFieldValue("contribuintes", [state.contribuintes]);

      // if (consultaFormData.result[0].inscricaoEstadual) {
      //   setDocumentoContribuinte(consultaFormData.result[0].inscricaoEstadual);
      // } else {
      //   setDocumentoContribuinte(consultaFormData.result[0].cpfCnpj);
      // }

      if (consultaFormData.result[0].cpfCnpj.length > 11) {
        setCnpj(consultaFormData.result[0].cpfCnpj);
        setCpf("");
      } else {
        setCnpj("");
        setCpf(consultaFormData.result[0].cpfCnpj);
      }
      if (consultaFormData.result[0].procedimentos.length > 0) {
        setProcedimentos(consultaFormData.result[0].procedimentos);
      } else {
        setProcedimentos(0);
      }

      setDataInicio(formatarData(consultaFormData.result[0].dataInicio));
      setDataFim(formatarData(consultaFormData.result[0].dataFim));

      setDados(consultaFormData.result[0]);

      if (consultaFormData.result[0].sequencialParteServico) {
        setSequencial(consultaFormData.result[0].sequencialParteServico);
        setTitulo("Parte de Serviço");
      } else if (consultaFormData.result[0].sequencialDenuncia) {
        setSequencial(consultaFormData.result[0].sequencialDenuncia);
        setTitulo("Denúncia");
      } else if (consultaFormData.result[0].sequencialCobranca) {
        setSequencial(consultaFormData.result[0].sequencialCobranca);
        setTitulo("Cobrança");
      } else {
        setSequencial("");
        setTitulo("");
      }
    }

    if (consultaFormErrors) {
      toast.error(consultaFormErrors.message);
    }
  }, [
    setFieldValue,
    values,
    consultaFormData,
    consultaFormErrors,
    consultaFormIsLoading,
    textoPadrao,
    state.contribuintes,
  ]);

  // Trazer orgão do usuário logado
  const { request: requestOrgao, data: dataOrgao, errors: errorOrgao, isLoading: isLoadingOrgao } = useApiClient();

  useEffect(() => {
    requestOrgao(apiRoutes.fiscalizacao.ordemservico.consultaOrgaoLogado);
  }, [requestOrgao]);

  useEffect(() => {
    if ((!dataOrgao && !errorOrgao) || isLoadingOrgao) return;
    if (dataOrgao && dataOrgao.result.length) {
      setSqOrgao(dataOrgao.result[0].sequencialOrgao);
      setSgOrgao(dataOrgao.result[0].siglaOrgao);
    }
  }, [setSqOrgao, setSgOrgao, dataOrgao, errorOrgao, isLoadingOrgao]);
  // ----------------

  const { setDocParams } = useDocumentoSpf();

  documentoSpf.exibir = (dadosSpf) => {
    setDocParams({ sqAberturaProcesso: dadosSpf.numeroAberturaProcesso });
  };

  return (
    <>
      {setGuardClient.linkRef}
      <EfisModal
        show={showViewSubstituicao}
        title="Texto da OS"
        size="lg"
        closeHandler={() => setShowViewSubstituicao(false)}
        primaryLabelVisible={false}
        secondaryLabel="Fechar"
        body={<span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(textoBody) }} />}
      />
      <h1 className="h3 mb-4 text-gray-800">Gerar Ordem de Serviço</h1>
      <div className="row">
        <div className="col-lg-12">
          {/* Conteúdo personalizado (card) */}
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <Row>
                <Col sm="11">
                  <h6 className="m-0 font-weight-bold text-primary flex-grow-1">A partir de SPF</h6>
                </Col>
                <Col sm="1" className="text-right">
                  <OverlayInfoAdicional data={formik.values} keyFieldName="numeroAberturaProcesso" />
                </Col>
              </Row>
            </div>
            <div className="card-body">
              <FormAlert
                formik={formik}
                data={gerarOrdemServicoData}
                errors={gerarOrdemServicoErrors}
                isLoading={gerarOrdemServicoIsLoading}
              />
              <Form noValidate onSubmit={formik.handleSubmit}>
                <Tabs defaultActiveKey="geral" transition={false} id="tabSpf">
                  <Tab
                    eventKey="geral"
                    title={
                      <span>
                        <GoAlert
                          color="red"
                          size={15}
                          hidden={
                            !(
                              formik.errors.sequencialTipoAcao ||
                              formik.errors.dataInicioFiscal ||
                              formik.errors.dataFinalFiscal ||
                              formik.errors.textoPadrao ||
                              formik.errors.quantidadeDiasOs ||
                              formik.errors.codigoDiretor
                            )
                          }
                        />
                        &nbsp;Dados Gerais
                      </span>
                    }
                  >
                    <Row>
                      <Col sm="2">
                        <b>Nº SPF </b>
                        <br />
                        <Row>
                          <Col className="mb-4">
                            {dados?.numeroAberturaProcesso}
                            {showButtonDownload(dados)}
                          </Col>
                        </Row>
                      </Col>
                      <Col sm="3">
                        <b> Contribuinte </b>
                        <br />
                        <span>{dados.nomeFormalContribuinte}</span>
                      </Col>
                      <Col sm="3">
                        <b> Inscrição Estadual </b>
                        <br />
                        <span>{dados.inscricaoEstadual !== null ? <IE value={dados.inscricaoEstadual} /> : "-"}</span>
                      </Col>
                      <Col sm="3">
                        <b> CPF/CNPJ </b>
                        <br />
                        <span>
                          <Id value={cnpj ?? cpf} />
                        </span>
                      </Col>
                    </Row>

                    <Row>
                      <Col sm="2">
                        <b> Domicílio </b>
                        <br />
                        <span>{dados.domicilioContribuinte !== null ? dados.domicilioContribuinte : "-"}</span>
                      </Col>
                      <Col sm="3">
                        <b> Endereço </b>
                        <br />
                        <span>
                          {dados.enderecoContribuinte !== null || dados.enderecoContribuinte !== ""
                            ? dados.enderecoContribuinte
                            : "-"}
                        </span>
                      </Col>
                      <Col sm="3">
                        <b> Período de Fiscalização</b>
                        <br />
                        <span>{`${dataInicio} a ${dataFim}`}</span>
                      </Col>
                      {sequencial !== "" ? (
                        <Col sm="3">
                          <b>{`Nº da ${titulo}`}</b>
                          <br />
                          <span>{` ${sequencial} `}</span>
                        </Col>
                      ) : null}
                    </Row>
                    <br />
                    <Row>
                      <Form.Group as={Col} sm={12} md={6}>
                        <span>Tipo de Ação Fiscal</span>
                        <SelectInputCachedFormik
                          formik={formik}
                          field="sequencialTipoAcao"
                          tipoItem="tipo_acao_preenchida"
                          disabled
                        />
                      </Form.Group>
                      <Form.Group as={Col} sm={12} md={3}>
                        <span>N° Máximo de Dias da OS</span>
                        <TextInputFormik formik={formik} field="quantidadeDiasOs" maxLength="3" type="number" />
                      </Form.Group>
                    </Row>
                    <Row>
                      {procedimentos !== 0 ? (
                        <Col>
                          {" "}
                          Procedimentos
                          <br />
                          <span>
                            {procedimentos.map((item) => (
                              <ul>
                                <li>
                                  <AiOutlineCheck className="text-success" />
                                  {` ${item}`}
                                </li>
                              </ul>
                            ))}
                          </span>
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                    {sgOrgao === "COFIS" ? (
                      <Row>
                        <Form.Group as={Col} sm={12} md={6}>
                          <span>Setor</span>
                          <SelectInputCachedFormik formik={formik} field="setor" tipoItem="orgaos-os" />
                        </Form.Group>
                      </Row>
                    ) : null}
                    <Row>
                      <Form.Group as={Col} sm={12} md={6}>
                        <SelectDiretor formik={formik} field="codigoDiretor" sqorgaologado={sqOrgao} />
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col} sm={12} md={12}>
                        <span>Texto Complementar</span>
                        <HtmlEditor formik={formik} field="textoPadrao" />
                      </Form.Group>
                    </Row>

                    <Row>
                      <Col>
                        <hr />
                        <Form.Label>
                          <strong>Texto da OS</strong>
                          <BiEdit
                            className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                            title={showTextoOs ? "Editar Texto" : "Fechar Edição"}
                            onClick={() => {
                              setShowTextoOs(!showTextoOs);
                            }}
                          />
                          <VscReplace
                            className="btn-lg  text-danger pa-0 p-0 btn btn-bg-transparent ml-2"
                            title="Visualizar texto com substituições"
                            onClick={() => {
                              setShowViewSubstituicao(true);
                              setTextoBody(
                                formik.values.textoPadraoOs
                                  .replace(
                                    "[PROCEDIMENTOS]",
                                    procedimentos
                                      ? ` ${procedimentos?.map((item) => ` - ${item} </br>`)} `.replace(",", "")
                                      : "[PROCEDIMENTOS]",
                                  )
                                  .replace("[PERIODO_FISCALIZACAO]", `${dataInicio} a ${dataFim}`),
                              );
                            }}
                          />
                        </Form.Label>
                        {!showTextoOs && <HtmlEditor formik={formik} field="textoPadraoOs" rows="5" />}
                        <hr hidden={!showTextoOs} />
                        <br />
                      </Col>
                    </Row>
                  </Tab>

                  {/* <Tab
                    eventKey="contribuinte"
                    title={
                      <span>
                        <GoAlert color="red" size={15} hidden={!formik.errors.contribuintes} />
                        &nbsp;Contribuintes
                      </span>
                    }
                  >
                    <ListaContribuinteAcaoFiscal
                      formik={formik}
                      field="contribuintes"
                      documento={documentoContribuinte}
                      origem="OS-1"
                    />
                  </Tab> */}

                  <Tab
                    eventKey="listaExecutoresOs"
                    title={
                      <span>
                        <GoAlert color="red" size={15} hidden={!formik.errors.listaExecutoresOs} />
                        &nbsp;Executores
                      </span>
                    }
                  >
                    <ListaExecutores formik={formik} field="listaExecutoresOs" />
                  </Tab>
                </Tabs>

                <Row>
                  <Col>
                    {formik.isSubmitting ? (
                      <span>
                        {" "}
                        <Spinner animation="border" role="status" /> Gerando Ordem de Serviço a partir de SPF...{" "}
                      </span>
                    ) : (
                      <Button
                        variant="primary"
                        className="mr-3"
                        disabled={desabilitarBotao || !formik.isValid}
                        onClick={() => {
                          gerarOrdemServico();
                          setDesabilitarBotao(true);
                        }}
                      >
                        Gerar OS
                      </Button>
                    )}
                    {"    "}
                    {!formik.isSubmitting && (
                      <Button variant="light" className="mr-3" onClick={formik.handleReset}>
                        Limpar
                      </Button>
                    )}
                    {"    "}
                    {!formik.isSubmitting && (
                      <Button variant="danger" className="mr-3" onClick={() => history.goBack()}>
                        Cancelar
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
      {/* fim da row */}
    </>
  );
};

export default FormSpfGerarOs;
